<div class="card">
  <div class="flex align-items-center justify-content-center">
    <img src="assets/Error_404.webp" i18n-alt alt="404 Error">
  </div>
  <div class="flex align-items-center justify-content-center h-1rem">
    <h2 i18n>PAGE NOT FOUND</h2>
  </div>
  <div class="card">
      <div class="flex-shrink-0 flex align-items-center justify-content-center text-center h-2rem p-4 m-3">
        <p i18n>The page you are looking for might have been removed, had its name changed or is temporary unavailable.</p>
      </div>
    </div>
  <div class="flex align-items-center justify-content-center">
    <p-button i18n-label label="Go back home" styleClass="p-button-warning" (click)="goBackHome()"></p-button>
  </div>
</div>
